import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import { Dialog, DialogTitle, DialogContent, DialogActions, IconButton, Button } from '@mui/material';
import Close from '@mui/icons-material/Close';
import PhotoCamera from '@mui/icons-material/PhotoCamera';
import { useStateValue } from '../../Contexto/store';

import Webcam from "react-webcam";

import { styleToolBar, styleTable, styleCameraButtons } from '../Tool/Style';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: '10px 12px',
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));

const BootstrapDialogTitle = (props) => {
    const { children, onClose, ...other } = props;

    return (
        <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
            {children}
            {onClose ? (
                <IconButton
                    aria-label="close"
                    style={styleToolBar.IconButton}
                    onClick={onClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8
                    }}>
                    <Close style={styleToolBar.Icon} />
                </IconButton>
            ) : null}
        </DialogTitle>
    );
};

BootstrapDialogTitle.propTypes = {
    children: PropTypes.node,
    onClose: PropTypes.func.isRequired,
};

let funcionCargarModal;
let validaCargaModal;

export const DialogoWebCam = ({ setCapture }) => {

    const [{ etiquetasIdioma }, dispatch] = useStateValue();

    const webcamRef = React.useRef(null);

    const capture = React.useCallback(
        () => {
            const imageSrc = webcamRef.current.getScreenshot();
            setCapture(imageSrc);
        },
        [webcamRef]
    );

    // Se declara la variable de estado que representa al idioma para las etiquetas del componente
    const [etiquetas, setEtiquetas] = useState({
        EtiquetasComponente: etiquetasIdioma ? etiquetasIdioma.EtiquetasComponente : DiccionarioEtiquetas.IdiomaDefault.Etiquetas,
        CodigoIdioma: etiquetasIdioma ? etiquetasIdioma.CodigoIdioma : DiccionarioEtiquetas.CodigoIdioma
    });

    useEffect(() => {
        // se llama al dispatch para que como tal se actualice el reducer
        setEtiquetas({
            EtiquetasComponente: etiquetasIdioma ? etiquetasIdioma.EtiquetasComponente : DiccionarioEtiquetas.IdiomaDefault.Etiquetas,
            CodigoIdioma: etiquetasIdioma ? etiquetasIdioma.CodigoIdioma : DiccionarioEtiquetas.CodigoIdioma
        });
    }, [etiquetasIdioma]);

    const videoConstraints = {
        width: 420,
        height: 320,
        facingMode: "user"
    };

    const [cargaModalWebCam, setCargaModalWebCam] = useState(false);
    funcionCargarModal = setCargaModalWebCam;
    validaCargaModal = cargaModalWebCam;

    return (
        <div>

            <BootstrapDialog
                onBackdropClick="false"
                onClose={mostrarDialogoWebCam}
                aria-labelledby="customized-dialog-title"
                open={cargaModalWebCam}
            >
                <BootstrapDialogTitle id="customized-dialog-title" onClose={mostrarDialogoWebCam}>
                    {etiquetas.EtiquetasComponente.DialogoWebCam.Et_TituloPrincipal}
                </BootstrapDialogTitle>
                <DialogContent dividers style={styleTable.TableHeader}>
                    <Webcam
                        audio={false}
                        height={320}
                        ref={webcamRef}
                        screenshotFormat="image/jpeg"
                        width={420}
                        videoConstraints={videoConstraints}
                    />
                </DialogContent>
                <DialogActions style={{ justifyContent: 'center' }}>
                    <Button style={styleCameraButtons.ButtonPrimary} onClick={capture} size="large">
                        {etiquetas.EtiquetasComponente.DialogoWebCam.Et_BtnCamara}
                    </Button>
                </DialogActions>
            </BootstrapDialog>
        </div>
    );
}

export const mostrarDialogoWebCam = () => {
    funcionCargarModal(!validaCargaModal);
}